import React from 'react';

const Vue_unmounted = () => {
  return (
    <div>
      <h1>Vue_unmounted Component</h1>
      <p>This is the Vue_unmounted tutorial page.</p>
    </div>
  );
}

export default Vue_unmounted;
